import AlternativeEditor from '@Alternatives/Alternatives/Components/AlternativeEditor.vue';
import { UpdateAlternativeCommandV1 } from '@Alternatives/Alternatives/Domain/commands-core';
import AlternativesCommands from '@Alternatives/Alternatives/Domain/commands-vue-component';
import AlternativesQueries from '@Alternatives/Alternatives/Domain/queries-vue-component';
import { EditAlternativePageReadModel } from '@Alternatives/Alternatives/Domain/readmodels';
import { ICommandBase } from '@Alternatives/cqrs';
import { AlternativeAttributeValueDTO } from '@Alternatives/Model';
import { ValidationError } from '@common/types';
import { ICommandStatus } from '@cqrs/cqrs';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: { AlternativeEditor }
})
export default class EditAlternativePage extends mixins(AlternativesQueries, AlternativesCommands)
{
    get alternativeId(): string { return this.$route?.params?.alternativeId ?? ''; }

    get formId(): number | null
    {
        const id = this.$route?.params?.formId;
        return id != null ? Number(id) : null;
    }

    rm: EditAlternativePageReadModel = null;

    errors: ValidationError[] = [];


    save(name: string, description: string, statusId: number, attributeValues: AlternativeAttributeValueDTO[])
    {
        this.errors = [];
        this.invokeUpdateAlternativeCommandV1(this.rm.UserId, this.rm.WorkspaceId, this.rm.ProjectId, this.rm.AlternativesListId, this.formId, this.alternativeId, name, description, statusId, attributeValues);
    }


    mounted()
    {
        this.runEditAlternativePageQueryV1(this.alternativeId, this.formId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "EditAlternativePageReadModel")
        {
            this.rm = model as EditAlternativePageReadModel;
            document.title = `Edit ${this.rm.AlternativeLabel} | TransparentChoice`;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateAlternativeCommandV1.matchType(cmd))
        {
            window.location.reload();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (UpdateAlternativeCommandV1.matchType(status.Command))
        {
            this.errors = status.ValidationErrors;
        }
    }
}